module.exports = __webpack_public_path__ + "img/report-3.0b72d883.jpg";